module.exports = __webpack_public_path__ + "img/datascreen.025524b1.png";